import { Deserializable } from '../deserializable';

export class LookupEntityTypes implements Deserializable {

    id: number;
    description: string;
    
    deserialize(input: any): this {
        Object.assign(this, input);
        return this;
    }
}
